import { ImageWithTextSectionStoryblok } from '../../types/storyblok';
import { StoryblokImage } from '../../base/StoryblokImage/StoryblokImage';
import React from 'react';
import classNames from 'classnames';
import { Box } from '../../base/Box/Box';
import { Type } from '../../base/Type/Type';
import Markup from '../../base/Markup/Markup';
import Link from '../../base/Link/Link';

export const Mobile = ({
  subheading,
  heading,
  richText,
  buttonText,
  buttonUrl,
  image,
}: ImageWithTextSectionStoryblok) => (
  <Box
    as="div"
    className={classNames(
      'mx-auto flex max-w-standard flex-col gap-6 sm:gap-12'
    )}
  >
    <Type as="h3" typography="subheading" className="mb-5">
      {subheading}
    </Type>
    <Type as="h2" className="mb-5 font-helvetica text-h2">
      {heading}
    </Type>

    <Box as="div">
      <StoryblokImage
        src={image}
        alt=""
        mode="responsive"
        maxWidth={600}
        className="rounded"
      />
    </Box>

    <Markup content={richText} className="text-p1" />

    <Box as="div">
      <Link href={buttonUrl} variant="primary" className="mt-12">
        {buttonText}
      </Link>
    </Box>
  </Box>
);
